import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { InvalidTicketComponent } from './invalid-ticket/invalid-ticket.component';
import { EnteridComponent } from './enterid/enterid.component';
import { CompleteprofileComponent } from './completeprofile/completeprofile.component';
import { ScanticketComponent } from './scanticket/scanticket.component';
import { ScanAnotherComponent } from './scan-another/scan-another.component';
import { AddprofileComponent } from './addprofile/addprofile.component';
import { EnterEmailComponent } from './enter-email/enter-email.component';
import { PasswordComponent } from './password/password.component';
import { SuccessComponent } from './success/success.component';
import { FinalCompleteComponent  } from './final-complete/final-complete.component';
import { CompletedExitComponent } from './completed-exit/completed-exit.component';
import { LoginComponent } from './login/login.component';

const routes: Routes = [
  {
    path: 'invalid',
    component: InvalidTicketComponent
  },
  {
    path: 'enteremail',
    component: EnterEmailComponent
  },
  {
    path: 'enterid',
    component: EnteridComponent
  },
  {
    path: 'completeprofile',
    component: CompleteprofileComponent
  },
  {
    path: 'addprofile',
    component: AddprofileComponent
  },
  {
    path: 'scanticket',
    component: ScanticketComponent
  },
  {
    path: 'scananother',
    component: ScanAnotherComponent
  },
  {
    path: 'password',
    component: PasswordComponent
  },
  {
    path: 'success',
    component: SuccessComponent
  },
  {
    path: 'finalsuccess',
    component: FinalCompleteComponent
  },
  {
    path: 'completeexit',
    component: CompletedExitComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: '**',
    redirectTo: '/scanticket'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})

export class SskRoutingModule {}


// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/routes/ssk.routing.module.ts